const loadedSources = new Set<string>();

export function preloadImages(sources: readonly string[]) {
  if (typeof window === "undefined") return;

  sources.forEach((src) => {
    if (!src || loadedSources.has(src)) {
      return;
    }

    const image = new Image();
    image.decoding = "async";
    image.src = src;
    loadedSources.add(src);
  });
}
